<template>
  <AppPage class="OrderDetail">
    <AppHeader
        title="DETALLES DEL PEDIDO"
        right-icon="cart-arrow-down"
        :left-action="onBack"
        :right-action="sendOrder"
    />
    <AppSection>
      <OrderDetails
          buttonText="REPETIR"
          buttonIcon="cart-arrow-down"
          :order="products"
          :date="date"
          :editable="false"
          @sendOrder="sendOrder"
      />
    </AppSection>
    <AppSection title="PRODUCTOS">
      <OrderProduct
          v-for="product in products"
          :key="product.key"
          :product="product"
      />
    </AppSection>
  </AppPage>
</template>

<script>
import { usersRef } from '../firebase'
import AppPage from '../components/Layout/AppPage'
import AppHeader from '../components/Layout/AppHeader'
import OrderDetails from '../components/Order/OrderDetails'
import OrderProduct from '../components/Order/OrderProduct'
import { orderBy } from 'lodash'

export default {
  components: { AppPage, AppHeader, OrderDetails, OrderProduct },
  computed: {
    order() {
      const orderId = this.$route.params.key
      const profile = this.$store.state.profile
      if (profile.orders) {
        return profile.orders[orderId]
      } else {
        return null
      }
    },
    products() {
      return this.order && this.order.order
        ? orderBy(Object.values(this.order.order)).reverse()
        : []
    },
    date() {
      return this.order ? this.order.date : null
    }
  },
  methods: {
    onBack() {
      this.$router.push('/')
    },
    async sendOrder() {
      let res = await window.confirm('¿Quieres repetir el pedido?')
      if (res) {
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order')
          .set(this.products)
        this.$router.push('/order')
      }
    }
  }
}
</script>

